<template>
  <div>
    <v-row align="end">
      <v-col cols="12">
        <v-range-slider
          label="Výber obdobia"
          v-model="filterORange"
          step="1"
          :min="minYear"
          :max="maxYear"
          ticks="always"
          tick-size="4"
          thumb-label="always"
        ></v-range-slider>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4" v-if="grafData0.length > 0">
        <bar-chart
          :chart-data="grafValues(0)"
          :options="grafOptions(0)"
        ></bar-chart>
      </v-col>
      <v-col cols="4" v-if="grafData3.length > 0">
        <bar-chart
          :chart-data="grafValues(3)"
          :options="grafOptions(3)"
        ></bar-chart>
      </v-col>
      <v-col cols="4" v-if="grafData4.length > 0">
        <bar-chart
          :chart-data="grafValues(4)"
          :options="grafOptions(4)"
        ></bar-chart>
      </v-col>
    </v-row>
  </div>
</template>

<script>
//import * as moment from "moment"
import * as Miscella from "@/plugins/miscella.js"
import BarChart from "./BarChart.js"

export default {
  data: function() {
    return {
      loading: false,
      filterORange: [this.minYear, this.maxYear],
      grafData0: [],
      grafData1: [],
      grafData2: [],
      grafData3: [],
      grafData4: []
    }
  },
  components: { BarChart },
  props: {
    bod: {
      type: Object,
      required: true
    },
    minYear: {
      type: Number,
      required: true
    },
    maxYear: {
      type: Number,
      required: true
    }
  },
  computed: {
    grafData3Max: function() {
      let myMax = 0
      //najdi abs.max. hodnotu
      for (let i = 0; i < this.grafData3.length; i++) {
        const data = this.grafData3[i]
        myMax = Math.max(myMax, Math.abs(data.OsaX))
        myMax = Math.max(myMax, Math.abs(data.OsaY))
      }
      //zaokruhli na najblizsie vyssie cislo - 100, 1000
      let n0 = Math.floor(Math.log10(myMax))
      let n10 = Math.pow(10, n0)
      let ret = Math.floor((myMax + n10) / n10) * n10
      return ret
    }
  },
  watch: {
    filterORange: {
      immediate: true,
      handler: function() {
        this.show()
      }
    }
  },
  methods: {
    grafValues: function(aIndex) {
      let ret = ""
      switch (aIndex) {
        case 0:
          ret = {
            datasets: [
              {
                data: this.grafData0.map(function(i) {
                  return { x: i.Posun, y: i.Hlbka }
                }),
                borderColor: "#00bfff",
                pointRadius: "1",
                borderWidth: "1",
                pointStyle: "circle",
                fill: "false",
                type: "line"
              }
            ]
          }
          break
        case 1:
          ret = {
            labels: this.grafData1.map(function(i) {
              return i.Hlbka
            }),
            datasets: [
              {
                backgroundColor: "#3333FF",
                borderColor: "black",
                borderWidth: 0,
                barThickness: 16,
                maxBarThickness: 16,
                data: this.grafData1.map(function(i) {
                  return [i.AzimutOd, i.AzimutDo]
                })
              }
            ]
          }
          break
        case 2:
          ret = {
            labels: this.grafData2.map(i => i.Hlbka),
            datasets: [
              {
                data: this.grafData2.map(i => i.AzimutOd),
                borderColor: "#00bfff",
                pointRadius: "1",
                borderWidth: "1",
                pointStyle: "circle",
                fill: "+1",
                type: "line"
              },
              {
                data: this.grafData2.map(i => i.AzimutDo),
                borderColor: "#00bfff",
                pointRadius: "1",
                borderWidth: "1",
                pointStyle: "circle",
                fill: false,
                type: "line"
              }
            ]
          }
          break
        case 3:
          ret = {
            datasets: [
              {
                data: this.grafData3.map(function(i) {
                  return { x: i.OsaX, y: i.OsaY }
                }),
                borderColor: "#00bfff",
                pointRadius: "1",
                borderWidth: "1",
                lineTension: 0,
                pointStyle: "circle",
                fill: "false",
                type: "line"
              }
            ]
          }
          break
        case 4:
          ret = {
            labels: this.grafData4.map(i => i.Datum),
            datasets: [
              {
                backgroundColor: "blue",
                borderWidth: 1,
                barThickness: 6,
                maxBarThickness: 8,
                data: this.grafData4.map(i => i.Hodnota)
              }
            ]
          }
          break
        default:
          break
      }
      return ret
    },
    grafOptions: function(aIndex) {
      let ret = ""
      switch (aIndex) {
        case 0:
          ret = {
            maintainAspectRatio: false,
            responsive: false,
            legend: {
              display: false
            },
            title: {
              display: false
            },
            scales: {
              xAxes: [
                {
                  type: "linear",
                  position: "top",
                  ticks: {
                    beginAtZero: true
                  },
                  scaleLabel: {
                    display: true,
                    labelString: "Posun [mm]"
                  }
                }
              ],
              yAxes: [
                {
                  type: "linear",
                  position: "left",
                  ticks: {
                    beginAtZero: true,
                    reverse: true,
                    min: 0,
                    maxTicksLimit: 10,
                    stepSize: 3
                  },
                  scaleLabel: {
                    display: true,
                    labelString: "Hĺbka [m]"
                  }
                }
              ]
            }
          }
          break
        case 1:
          ret = {
            maintainAspectRatio: false,
            responsive: false,
            legend: { display: false },
            scales: {
              xAxes: [
                {
                  position: "top",
                  ticks: {
                    min: 0,
                    max: 360
                  },
                  scaleLabel: {
                    display: true,
                    labelString: "Azimut [°]"
                  }
                }
              ],
              yAxes: [
                {
                  position: "left",
                  ticks: {
                    beginAtZero: true,
                    //reverse: true,
                    maxTicksLimit: 10,
                    min: 0,
                    stepSize: 3
                  },
                  scaleLabel: {
                    display: false,
                    labelString: "Hĺbka [m] xxx"
                  }
                }
              ]
            }
          }
          break
        case 2:
          ret = {
            maintainAspectRatio: false,
            responsive: false,
            legend: { display: false },
            scales: {
              xAxes: [
                {
                  position: "left",
                  ticks: {
                    beginAtZero: true,
                    //reverse: true,
                    min: 0,
                    stepSize: 3
                  },
                  scaleLabel: {
                    display: false,
                    labelString: "Hĺbka [m]"
                  }
                }
              ],
              yAxes: [
                {
                  position: "top",
                  ticks: {
                    maxTicksLimit: 10,
                    min: 0,
                    maxRotation: 100,
                    max: 360
                  },
                  scaleLabel: {
                    display: true,
                    labelString: "Azimut [°]"
                  }
                }
              ]
            }
          }
          break
        case 3:
          ret = {
            maintainAspectRatio: true,
            responsive: false,
            legend: {
              display: false
            },
            title: {
              display: false
            },
            scales: {
              xAxes: [
                {
                  type: "linear",
                  ticks: {
                    beginAtZero: true,
                    min: this.grafData3Max * -1,
                    max: this.grafData3Max
                  },
                  scaleLabel: {
                    display: true,
                    labelString: "[mm]"
                  }
                }
              ],
              yAxes: [
                {
                  type: "linear",
                  ticks: {
                    beginAtZero: true,
                    min: this.grafData3Max * -1,
                    max: this.grafData3Max
                  },
                  scaleLabel: {
                    display: true,
                    labelString: "[mm]"
                  }
                }
              ]
            }
          }
          break
        case 4:
          ret = {
            maintainAspectRatio: false,
            responsive: false,
            legend: {
              display: false
            },
            title: {
              display: false
            },
            scales: {
              xAxes: [
                {
                  type: "time",
                  time: {
                    unit: "year"
                  }
                }
              ],
              yAxes: [
                {
                  type: "linear",
                  scaleLabel: {
                    display: true,
                    labelString: "[mm]"
                  }
                }
              ]
            }
          }
          break
        default:
          break
      }
      return ret
    },
    urlFetch: function() {
      let url = "/chart/ink"
      url += "?bodID=" + Miscella.normalizeString(this.bod.ID)
      url +=
        "&datumOd=" +
        Miscella.formatDatumEx(this.filterORange[0] + "-01-01", "YYYY-MM-DD")
      url +=
        "&datumDo=" +
        Miscella.formatDatumEx(this.filterORange[1] + "-12-31", "YYYY-MM-DD")
      url += "&hlbka=1"
      return url
    },
    show: async function() {
      this.grafData0 = []
      this.grafData1 = []
      this.grafData2 = []
      this.grafData3 = []
      this.grafData4 = []
      try {
        this.loading = true
        let response = await this.$axios.get(this.urlFetch())
        if (response.status === 200) {
          this.grafData0 = response.data.data0
          this.grafData1 = response.data.data1
          this.grafData2 = response.data.data2
          this.grafData3 = response.data.data3
          this.grafData4 = response.data.data4
          if (this.grafData0 === null) {
            this.grafData0 = []
          }
          if (this.grafData1 === null) {
            this.grafData1 = []
          }
          if (this.grafData2 === null) {
            this.grafData2 = []
          }
          if (this.grafData3 === null) {
            this.grafData3 = []
          }
          if (this.grafData4 === null) {
            this.grafData4 = []
          }
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      } finally {
        this.loading = false
      }
    }
  },
  mounted: function() {}
}

/*
//Download Chart Image
document.getElementById("download").addEventListener('click', function(){
  var url_base64jp = document.getElementById("lineChart").toDataURL("image/jpg");
  var a =  document.getElementById("download");
  a.href = url_base64jp;
});
*/
</script>
